/* eslint-disable  */
import { Link } from "react-router-dom";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import Select from "react-select";
import { Form, Field } from "react-final-form";
import useCustomerHook from "./useCustomerHook";
import "./index.css";

const productOptions = [
  { value: "", label: "Select Currency" },
  { value: "USD", label: "US dollar" },
  { value: "EUR", label: "Euro" },
  { value: "GBP", label: "Pound sterling" },
];

const Error = ({ name }) => (
  <Field
    name={name}
    subscription={{ error: true, touched: true }}
    render={({ meta: { error, touched } }) =>
      error && touched ? (
        <span style={{ color: "red", fontSize: "12px" }}>{error}</span>
      ) : null
    }
  />
);

const required = (value) => (value ? undefined : "Required");
const composeValidators = (...validators) => (value) =>
  validators.reduce((error, validator) => error || validator(value), undefined);

function transformCustomerData(input) {
  return {
    full_name: input.full_name || "",
    email: input.email || "",
    mobile_number: input.phone ? `${input.phone}` : "",
    password: "",
    customer: {
      notes: input?.notes || "",
      company_name: input?.company_name || "",
      lead_source: input?.lead_source || "",
      lead_stage: input?.lead_stage?.value || "",
      billing_address: {
        name: input.billing_name || "",
        address_line1: input.billing_address1 || "",
        address_line2: input.billing_address2 || "",
        country: input.billing_country || "",
        state: input.billing_state || "",
        city: input.billing_city || "",
        pincode: input.billing_pincode || "",
      },
      shipping_address: {
        name: input.shipping_name || "",
        address_line1: input.shipping_address1 || "",
        address_line2: input.shipping_address2 || "",
        country: input.shipping_country || "",
        state: input.shipping_state || "",
        city: input.shipping_city || "",
        pincode: input.shipping_pincode || "",
      },
    },
  };
}

export default function AddCustomerForm({ isEdit, uuid, data }) {
  const {
    submitCustomerMutation,
    submitCustomerLoading,
    updateCustomerMutation,
    setSubmitting,
    submitting,
    sendWelcomeEmailMutation,
  } = useCustomerHook();

  const onSubmit = (values) => {
    setSubmitting(true);
    if (!isEdit) {
      submitCustomerMutation.mutate(transformCustomerData(values));
    } else {
      updateCustomerMutation.mutate({
        uuid: uuid,
        customerData: transformCustomerData(values),
      });
    }
  };

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={isEdit ? data : {}}
      render={({
        handleSubmit,
        form,
        values,
        submitFailed,
        hasValidationErrors,
        pristine,
      }) => (
        <form onSubmit={handleSubmit} noValidate>
          <div className="">
            <div className="form-group-item">
              <h5 className="form-title">Basic Details</h5>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="input-block mb-3">
                    <label>
                      Company Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      name="company_name"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Company Name"
                      validate={required}
                    />
                    <Error name="company_name" />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="input-block mb-3">
                    <label>
                      Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      name="full_name"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Name"
                      validate={required}
                    />
                    <Error name="full_name" />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="input-block mb-3">
                    <label>
                      Email <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      name="email"
                      component="input"
                      type="email"
                      className="form-control"
                      placeholder="Enter Email Address"
                      validate={required}
                    />
                    <Error name="email" />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="input-block mb-3">
                    <label>
                      Phone <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field name="phone" validate={required}>
                      {({ input, meta }) => (
                        <>
                          <PhoneInput
                            defaultCountry="IN"
                            value={input.value}
                            onChange={input.onChange}
                            placeholder="Enter Phone Number"
                            className="input-block form-control"
                            style={{
                              display: "flex",
                            }}
                          />
                          {meta.touched && meta.error && (
                            <span style={{ color: "red", fontSize: "12px" }}>
                              {meta.error}
                            </span>
                          )}
                        </>
                      )}
                    </Field>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="input-block mb-3">
                    <label>Notes</label>
                    <Field
                      name="notes"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Notes"
                    />
                    <Error name="notes" />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="input-block mb-3">
                    <label>Lead Source </label>
                    <Field
                      name="lead_source"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Lead Source"
                    />
                  </div>
                </div>

                <div
                  className="col-lg-4 col-md-6 col-sm-12"
                  style={{
                    zIndex: 99999,
                  }}
                >
                  <div className="input-block mb-3">
                    <label>Lead Stage</label>
                    <Field name="lead_stage">
                      {({ input }) => (
                        <Select
                          {...input}
                          options={[
                            { value: "new", label: "New" },
                            { value: "technical", label: "Technical" },
                            { value: "false_inquiry", label: "False inquiry" },
                            { value: "follow_up", label: "Follow up" },
                          ]}
                          placeholder="Select Lead Stage"
                        />
                      )}
                    </Field>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group-item">
              <div className="row">
                <div className="col-md-6">
                  <div className="billing-btn mb-2">
                    <h5 className="form-title">Billing Address</h5>
                  </div>
                  <div className="input-block mb-3">
                    <label>Name</label>
                    <Field
                      name="billing_name"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Name"
                    />
                    <Error name="billing_name" />
                  </div>
                  <div className="input-block mb-3">
                    <label>Address Line 1</label>
                    <Field
                      name="billing_address1"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Address 1"
                    />
                    <Error name="billing_address1" />
                  </div>
                  <div className="input-block mb-3">
                    <label>Address Line 2</label>
                    <Field
                      name="billing_address2"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Address 2"
                    />
                    <Error name="billing_address2" />
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-12">
                      <div className="input-block mb-3">
                        <label>Country</label>
                        <Field
                          name="billing_country"
                          component="input"
                          type="text"
                          className="form-control"
                          placeholder="Country"
                        />
                        <Error name="billing_country" />
                      </div>
                      <div className="input-block mb-3">
                        <label>City</label>
                        <Field
                          name="billing_city"
                          component="input"
                          type="text"
                          className="form-control"
                          placeholder="City"
                        />
                        <Error name="billing_city" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className="input-block mb-3">
                        <label>State</label>
                        <Field
                          name="billing_state"
                          component="input"
                          type="text"
                          className="form-control"
                          placeholder="State"
                        />
                        <Error name="billing_state" />
                      </div>
                      <div className="input-block mb-3">
                        <label>Pincode</label>
                        <Field
                          name="billing_pincode"
                          component="input"
                          type="text"
                          className="form-control"
                          placeholder="Pincode"
                        />
                        <Error name="billing_pincode" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="billing-btn">
                    <h5 className="form-title mb-0">Shipping Address</h5>
                    <div
                      to="#"
                      className="btn btn-primary"
                      type="button"
                      onClick={() => {
                        form.batch(() => {
                          form.change("shipping_name", values.billing_name);
                          form.change(
                            "shipping_address1",
                            values.billing_address1
                          );
                          form.change(
                            "shipping_address2",
                            values.billing_address2
                          );
                          form.change(
                            "shipping_country",
                            values.billing_country
                          );
                          form.change("shipping_city", values.billing_city);
                          form.change("shipping_state", values.billing_state);
                          form.change(
                            "shipping_pincode",
                            values.billing_pincode
                          );
                        });
                      }}
                    >
                      Copy from Billing
                    </div>
                  </div>
                  <div className="input-block mb-3">
                    <label>Name</label>
                    <Field
                      name="shipping_name"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Name"
                    />
                    <Error name="shipping_name" />
                  </div>
                  <div className="input-block mb-3">
                    <label>Address Line 1</label>
                    <Field
                      name="shipping_address1"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Address 1"
                    />
                    <Error name="shipping_address1" />
                  </div>
                  <div className="input-block mb-3">
                    <label>Address Line 2</label>
                    <Field
                      name="shipping_address2"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Address 2"
                    />
                    <Error name="shipping_address2" />
                  </div>
                  <div className="row">
                    <div className="col-lg-6 col-md-12">
                      <div className="input-block mb-3">
                        <label>Country</label>
                        <Field
                          name="shipping_country"
                          component="input"
                          type="text"
                          className="form-control"
                          placeholder="Country"
                        />
                        <Error name="shipping_country" />
                      </div>
                      <div className="input-block mb-3">
                        <label>City</label>
                        <Field
                          name="shipping_city"
                          component="input"
                          type="text"
                          className="form-control"
                          placeholder="City"
                        />
                        <Error name="shipping_city" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className="input-block mb-3">
                        <label>State</label>
                        <Field
                          name="shipping_state"
                          component="input"
                          type="text"
                          className="form-control"
                          placeholder="State"
                        />
                        <Error name="shipping_state" />
                      </div>
                      <div className="input-block mb-3">
                        <label>Pincode</label>
                        <Field
                          name="shipping_pincode"
                          component="input"
                          type="text"
                          className="form-control"
                          placeholder="Pincode"
                        />
                        <Error name="shipping_pincode" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="form-group-customer customer-additional-form">
              <div className="row">
                <h5 className="form-title">Bank Details</h5>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="input-block mb-3">
                    <label>
                      Bank Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      name="bank_name"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Bank Name"
                      validate={required}
                    />
                    <Error name="bank_name" />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="input-block mb-3">
                    <label>
                      Branch <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      name="bank_branch"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Branch Name"
                      validate={required}
                    />
                    <Error name="bank_branch" />
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <div className="input-block mb-3">
                    <label>
                      Account Holder Name{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      name="bank_account_holder_name"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Account Holder Name"
                      validate={required}
                    />
                    <Error name="bank_account_holder_name" />
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <div className="input-block mb-3">
                    <label>
                      Account Number <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      name="bank_account_number"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter Account Number"
                      validate={required}
                    />
                    <Error name="bank_account_number" />
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <div className="input-block mb-3">
                    <label>
                      IFSC <span style={{ color: "red" }}>*</span>
                    </label>
                    <Field
                      name="bank_ifsc"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter IFSC Code"
                      validate={required}
                    />
                    <Error name="bank_ifsc" />
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <div className="input-block mb-3">
                    <label>
                      SWIFT Code
                    </label>
                    <Field
                      name="swift_code"
                      component="input"
                      type="text"
                      className="form-control"
                      placeholder="Enter SWIFT Code"
                    />
                    <Error name="swift_code" />
                  </div>
                </div>
              </div>
            </div> */}
            <div className="add-customer-btns text-end">
              <Link to="/customers" className="btn customer-btn-cancel">
                Cancel
              </Link>
              <button
                type="submit"
                className="btn customer-btn-save"
                disabled={submitting || hasValidationErrors}
              >
                Save Changes
                {submitting && (
                  <span
                    className="spinner-border spinner-border-sm ms-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
              </button>
              {isEdit && (
                <button
                  type="button"
                  className="btn customer-btn-save "
                  style={{
                    marginLeft: 10,
                  }}
                  onClick={() => sendWelcomeEmailMutation.mutate(uuid)}
                  disabled={sendWelcomeEmailMutation.isLoading}
                >
                  Send Welcome Email
                  {sendWelcomeEmailMutation.isLoading && (
                    <span
                      className="spinner-border spinner-border-sm ms-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                </button>
              )}
              <button
                className="btn customer-btn-save"
                style={{ display: "none" }}
                disabled={submitting || pristine || hasValidationErrors}
              >
                Create Customer Login
                {submitting && (
                  <span
                    className="spinner-border spinner-border-sm ms-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
              </button>
              {submitFailed && hasValidationErrors && (
                <div style={{ color: "red", marginTop: 10 }}>
                  Please fill all required fields.
                </div>
              )}
            </div>
          </div>
        </form>
      )}
    />
  );
}
